/**
 * RIS utility functions
 */

/**
 * Return the given Date in the bizarre RIS date format.
 * Note that this always includes the time portion (which isn't
 * necessarily always required, according to RIS format rules).
 * As such, this is only useful for datetime stamps, not
 * any of the other weird things you can do in RIS.
 */
export function formatDate(dt: Date): string {
// TODO: check timezone stuff here, too. Need to make sure we maintain timezone.
	const year = new Intl.DateTimeFormat("en", {year: "numeric"}).format(dt);
	const month = new Intl.DateTimeFormat("en", {month: "2-digit"}).format(dt);
	const day = new Intl.DateTimeFormat("en", {day: "2-digit"}).format(dt);
	const time = new Intl.DateTimeFormat("en", {hour: "2-digit", hour12: false, minute: "2-digit", second: "2-digit"}).format(dt);

	return `${year}/${month}/${day}/${time}`;
};

/**
 * Replace a specific key in RIS data with a new value.
 * This function will replace any instance of the key
 * in the data, so it should probably be used only when
 * you know there is only one instance of the key.
 */
export function replaceKey(key: string, value: string, risIn: string): string {
	const lineEnd = "\r\n";
	const separator = "  - ";
	const out = [];

	const rows = risIn.split(lineEnd);
	for (const row of rows) {
		const [k, v] = row.split(separator); // eslint-disable-line @typescript-eslint/no-unused-vars
		if (k === key)
			out.push(k + separator + value);
		else
			out.push(row);
	}

	return out.join(lineEnd);
};

export default {
	formatDate,
	replaceKey
};
